import styled from "styled-components";

export const RenderListWrapper = styled.section`
  display: flex;
  /* display: grid; */
  /* grid-template-columns: 1fr 1fr; */
  gap: 16px;
  row-gap: 34px;
  & > * {
    flex-basis: 100%;
    height: 100%;
  }
  & article {
    height: 88%;
  }
  width: 100%;
`;

export const AttributeInnerCardWrapper = styled.div`
  background: #fdf2e1;
  border-radius: 4px;
  padding: 14px 12px;
  width: ${({ width }) => (width ? width : "100%")};
`;

export const AttributeDefaultHeaderWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const MaternityDetailWrapper = styled.article`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 18px;
  column-gap: 12px;
  & article {
    height: 88%;
  }
  & > :first-child {
    grid-column: 1/3;
  }
`;

export const MaternityDeliveryDetailWrapper = styled.section`
  display: flex;
  gap: 12px;
  flex-direction: ${({ direction }) => (direction ? "column" : "row")};
  & > div {
    flex-basis: 100%;
  }
  & > section {
    display: flex;
    gap: 8px;
  }
`;

export const RoomRentDetailWrapper = styled.section`
  padding: 24px 14px;
  border: 1px solid #231a3d66;
  border-radius: 4px;
  & > section {
    display: flex;
    gap: 24px;
    & > div {
      flex-basis: 100%;
    }
    & article {
      display: flex;
      gap: 10px;
    }
  }
`;
